import * as Sentry from '@sentry/react';

export const handleReducerError = messaage => (state, action) => {
  console.error(messaage, action.error);
  state.error = action.error;
  Sentry.captureException(action.error);
};
